import request from './request';

const script = document.createElement('script');
script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
document.head.appendChild(script);


let appid = "wxd23b64799a11ee79";

const setUserInfoToStorage = (result) => {
	console.log("setUserInfoToStorage")
	console.log(result.data.id);
	console.log(result.data.id === null);
	if (result.data.id === "" || result.data.id === null) {
		localStorage.setItem('loginFlag', 'fail');
		console.log("loginFlag=" + localStorage.getItem('loginFlag'));
		return;
	}
	if (localStorage.getItem('loginFlag')) {
		localStorage.removeItem('loginFlag');
	}
	if (localStorage.getItem('loginNickName')) {
		localStorage.removeItem('loginNickName');
	}
	if (localStorage.getItem('userToken')) {
		localStorage.removeItem('userToken')
	}
	if (localStorage.getItem('loginUserName')) {
		localStorage.removeItem('loginUserName')
	}
	if (localStorage.getItem('loginUserId')) {
		localStorage.removeItem('loginUserId')
	}
	if (localStorage.getItem('deviceId')) {
		localStorage.removeItem('deviceId');
	}
	localStorage.setItem('loginFlag', true);
	localStorage.setItem('deviceId', result.data.deviceId);
	localStorage.setItem("userToken", result.data.token);
	localStorage.setItem('loginNickName', result.data.nickName);
	localStorage.setItem('loginUserId', result.data.id);
	localStorage.setItem('loginUserName', result.data.userName);

}

async function weChatAccessToken(code) {
	console.log("weChatAccessToken1");
	await request.post('/login/wechatQrLogin', {
		code: code,
		platform: "openWeb",
	}, {
		headers: {
			'Content-Type': 'application/json;charset=utf-8'
		}
	}).then(response => {
		const result = response.data; // 将接口返回的数据赋值给result
		console.log(result.code);
		if (result.code === "200") {
			console.log("weChatAccessToken" + result.data);
			setUserInfoToStorage(result);
		} else {
			localStorage.setItem('loginFlag', false);
		}
	}).catch(error => {
		console.log("loginPage error:" + error);
		localStorage.setItem('loginFlag', false);

	});
}

export default {
	getLoginScanCode: function () {
		console.log("getLoginScanCode");
		const redirect_uri = encodeURIComponent('https://www.zhuxitech.cn/#/login');
		let scope = "snsapi_login";
		let state = "openWeb";

		// console.log(url);
		window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
	},

	loginFromWechatQrCode: async function (code) {
		console.log("loginFromWechatQrCode");
		await weChatAccessToken.call(this, code);
		console.log("weChatAccessToken end");
	},

	getLoginDirectScanCode: function () {
		console.log("getLoginDirectScanCode");
		let scope = "snsapi_login";
		let state = "openWeb";
		const redirect_uri = encodeURIComponent('https://www.zhuxitech.cn/#/login');

		setTimeout(function () {
			new window.WxLogin({
				self_redirect: true,
				id: "login_container",
				appid: appid,
				scope: scope,
				redirect_uri: redirect_uri,
				state: state
			});
		}, 2000);


	},
}
